import { OppButton } from '../ui/control';
import type React from 'react';

interface OppProfileStat {
  label: string;
  value: number | string;
  highlight?: boolean;
}

interface OppProfileTabsProps {
  tabs: { id: string; label: string; icon: React.ElementType }[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  stats: OppProfileStat[];
}

export function OppProfileTabs({ tabs, activeTab, onTabChange, stats }: OppProfileTabsProps) {
  return (
    <div className="mt-5 border-b border-[hsl(var(--opp-border))]">
      <div className="hidden items-center justify-between pt-1.5 md:flex">
        <div role="tablist" className="opp-page-context-navigation flex">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <OppButton
                key={tab.id}
                role="tab"
                aria-selected={activeTab === tab.id}
                onClick={() => onTabChange(tab.id)}
                className={`flex items-center gap-1.5 border-b-2 px-4 py-3 text-sm font-medium transition-colors ${
                  activeTab === tab.id
                    ? 'border-[hsl(var(--opp-accent))] text-[hsl(var(--opp-ink))]'
                    : 'border-transparent text-[hsl(var(--opp-muted))] hover:text-[hsl(var(--opp-accent-strong))]'
                }`}
              >
                <Icon className="h-4 w-4" />
                {tab.label}
              </OppButton>
            );
          })}
        </div>

        <div className="flex items-center gap-6 pb-3">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className={`text-lg font-bold ${stat.highlight ? 'text-[hsl(var(--opp-accent-strong))]' : 'text-[hsl(var(--opp-ink))]'}`}>
                {stat.value}
              </div>
              <div className="text-xs text-[hsl(var(--opp-muted))]">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="md:hidden">
        <div role="tablist" className="opp-page-context-navigation flex">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <OppButton
                key={tab.id}
                role="tab"
                aria-selected={activeTab === tab.id}
                onClick={() => onTabChange(tab.id)}
                className={`flex flex-1 flex-col items-center gap-1 border-b-2 py-3 text-sm font-medium transition-colors ${
                  activeTab === tab.id
                    ? 'border-[hsl(var(--opp-accent))] text-[hsl(var(--opp-ink))]'
                    : 'border-transparent text-[hsl(var(--opp-muted))]'
                }`}
              >
                <Icon className="h-4 w-4" />
                <span className="text-xs">{tab.label}</span>
              </OppButton>
            );
          })}
        </div>
      </div>
    </div>
  );
}
